Drupal.behaviors.megaMenu = {
  attach(context) {
    
    // zruseni contextu, protoze tam je stejne zamek window.mega_menu_init
    // problem je v pripade, ze context byl primo selector nav - tedy v nem uz se podrizeny nav nemohl nalezt..
    var menu = $('nav > #mega-nav');
    
    // pro jednosloupcovy je to jinaci
    if ($(context).hasClass('upce-menu__one_column')) {
      menu = $('.upce-menu__one_column > #mega-nav');
    }

    if (menu && menu.length > 0) { 

      if (window.mega_menu_init) {
        return false;
      }

      // nastaveni - ma byt jinde - samostatne TODO
      $('.rt-reg img:not(.image)').each(function(index, img) {          
          let width = $(img).attr('width');
          const height = $(img).attr('height');
          const srcset = $(img).attr('srcset');
          const dataAlign = $(img).data('align');
          if (width && srcset == undefined) { // pokud ma obrazek srcset - nenastavujeme ho

            let display = 'initial';
            // pokud mame sirku v % nepridavame px
            if (width.indexOf('%') === -1 && width.indexOf('px') === -1) {
              width = width + 'px';
            }
            
            if (dataAlign && dataAlign === 'center') {
              display = 'block';
              $(img).css('margin', 'auto');
            }

            $(img).css('display', display);

            $(img).css('width', width);
            $(img).css('height', height + 'px');

          }
      });

      // funcknost aby se menu nezobrazovalo na hover, ale na klikani      
      var $mainMenuItems = $(menu).find('> ul.mega-menu > li.mega-menu__item.mega-menu__item--with-sub');

      // klinutim mimo menu se vybrane menu skryje
      $(context).on('click', (event) => {
        if (!($(event.target).hasClass('mega-menu__link') && $(event.target).hasClass('mega-menu__link--with-sub'))) {
          resetMenu(-1, $mainMenuItems);
        }
      });
      
      resetMenu(-1, $mainMenuItems);

      $mainMenuItems.each((i, item) => {
        $(item).on('click', (event) => {

          // nelze prokliknou submenu (a na 0. urovni) - s vyjimkou na to, ze menu neobsahuje polozky
          // pokud neobsahuje polozky - lze prokliknout
          if ($(item).find('> span.expand-sub').length > 0) {

            // nelze prokliknou submenu (a na 0. urovni) - pokud 
            event.preventDefault();

            // kliknuti na prostor sekce - aby se nezavrelo cele menu
            // console.log(event.target); // pro testovani - nemazat
            // vyjimky na tridy..
            if ($(event.target).hasClass('mega-menu__item--sub-1') || $(event.target).hasClass('mega-menu__item--sub-2') || $(event.target).hasClass('mega-menu__link--sub-1')  || $(event.target).hasClass('mega-menu--sub-1')) {            
              return false; 
            };  

            resetMenu(i, $mainMenuItems);

            $(item).toggleClass('mega-menu__item--selected');

            var $submenu = $(this).find('> .mega-menu--sub');
            $submenu.toggleClass('mega-menu--sub--visible');
          }

        });
      });
      
      // nelze prokliknout odkaz v 1.urovni
      $('.mega-menu__link--sub-1').each((i, item) => {
        $(item).on('click', (event) => {
          event.preventDefault();
        });
      });

      // skryti vsech 1. podmenicek
      /**
       * 
       * @param {int} i - index, ktery se nema skryvat (0 == vse)
       * @param {JQuery} $mainMenuItem - polozka hlavniho menu
       */
      function resetMenu(i, $mainMenuItem) {
        
        // odznaceni vsech polozek v hlavnim menu, jako selected
        $mainMenuItem.each((k, item) => {
          if (i !== k) {
            $(item).removeClass('mega-menu__item--selected');
          }
        });

        // odznaceni vsech podmenicek jak viditelnych
        $mainMenuItem.find('> .mega-menu--sub').each((j, item) => {
          if (i !== j) {
            $(item).removeClass('mega-menu--sub--visible');
          }            
        });

      }
      
      // Mobilni zobrazeni - prokliky menu

      // hlavni menicko
      // Mobile Menu Show/Hide. 
      const $toggleExpand = $(context).find('#toggle-expand');
      $toggleExpand.on('click', (event) => {
        event.preventDefault();
        
        // vysunuti a zasunuti menicka
        slideMenu($(menu), 'mega-nav--open');

      });

      
      // 1. polozky menu
      const $expandMenu = $(menu).find('> ul.mega-menu > .mega-menu__item');
      
      $expandMenu.each((i, item) => {
        $(item).on('click', (event) => {

          event.stopPropagation();
          
          $(item).find('> .expand-sub').toggleClass('expand-sub--open');
          slideMenu($(item).find('> .mega-menu--sub-1'), 'mega-menu--sub-open');
          
        });
      });

      // 2. polozky menu
      const $expandSubMenu = $(menu).find('> ul.mega-menu > .mega-menu__item .mega-menu--sub-1 > .mega-menu__item--sub-1');

      $expandSubMenu.each((i, item) => {
        $(item).on('click', (event) => {

          event.stopPropagation(); // misto return false
          
          $(item).find('> .expand-sub').toggleClass('expand-sub--open');          
          slideMenu($(item).find('> .mega-menu--sub-2'), 'mega-menu--sub-open');
          
        });
      });

      // proklik linku (2. uroven) tak, aby se nezavrelo, po prokliknuti, menicko 
      $('.mega-menu__link--sub-2').each((i, item) => {
        $(item).on('click', (event) => {
          event.stopPropagation();
        });
      });
    
      
      // rozbaleni a zabaleni - pouze pro mobilni verzi - puvodni reseni je: $menu.toggleClass(openClassName)
      // $menu JQuerySelector - menu element
      // openClassName string - nazev css tridy pro zobrazeni
      // speed = 500          - rychlost
      function slideMenu($menu, openClassName, speed = 500) {

        if( isMobileBreakpoint() ) {        
          if ($menu.hasClass(openClassName)) {
            $menu.slideUp(speed, () => {
              $menu.toggleClass(openClassName);
            });
          } else {
            $menu.toggleClass(openClassName).hide().slideDown(speed);
          }
        }
        
      }

      // kontrola na mobilni zobrazeni
      function isMobileBreakpoint() {
        return $('#toggle-expand:visible').length == 1;
      }

      window.mega_menu_init = true;
    }
  },
};
